import React from 'react';

const PersonalityFilterIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M7.87274 15.7841C8.86115 17.6005 10.7866 18.8332 13 18.8332C16.2217 18.8332 18.8334 16.2216 18.8334 12.9999C18.8334 10.7964 17.6116 8.87832 15.8086 7.88599"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M11 14.75H15.3334" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14.75 11.25H14.7558" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <g clipPath="url(#clip0_1372_8880)">
      <path
        d="M7.00002 12.8334C10.2217 12.8334 12.8334 10.2217 12.8334 7.00008C12.8334 3.77842 10.2217 1.16675 7.00002 1.16675C3.77836 1.16675 1.16669 3.77842 1.16669 7.00008C1.16669 10.2217 3.77836 12.8334 7.00002 12.8334Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.66669 8.16675C4.66669 8.16675 5.54169 9.33341 7.00002 9.33341C8.45835 9.33341 9.33335 8.16675 9.33335 8.16675"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M5.25 5.25H5.257" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.75 5.25H8.757" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_1372_8880">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default PersonalityFilterIcon;
